import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { COLOR_APP, COLOR_TEXT } from "../constants";

function BasicModal({
  rightButtonColor,
  show,
  onHide,
  title,
  leftButtonName,
  rightButtonName,
  Illustration,
  okay,
}) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body
        style={{
          // height: "276px",
          // width: "540px",
          marginLeft: "0px",
        }}
      >
        <div>
          <img
            src={Illustration}
            alt="Illustration"
            style={{
              width: "170px",
              height: "110px",
              padding: "none",
            }}
          />
        </div>
        <h4
          style={{
            fontSize: "18px",
            margin: "16px 20px 16px 0px",
            color: "#252A31",
            fontWeight: "700",
            fontFamily: "FontLao2",
          }}
        >
          {title}
        </h4>
        <div
          style={{
            display: "flex",
            padding: "0px 44px 0px 0px",
            justifyContent: "end",
          }}
        >
          <Button
            variant="secondary"
            onClick={onHide}
            style={{
              marginRight: "8px",
              width: 72,
              height: 47,
              color: " #252A31",
              background: "#E8EDF1",
              border: "0px",
            }}
          >
            {leftButtonName}
          </Button>
          <Button
            variant="primary"
            onClick={okay}
            style={{
              marginRight: "8px",
              width: 79,
              height: 47,
              background: rightButtonColor ? rightButtonColor : COLOR_APP,
              border:
                "1px solid " + rightButtonColor ? rightButtonColor : COLOR_TEXT,
            }}
          >
            {rightButtonName}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default BasicModal;
